/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PRPTemplatesRecipientNullable } from './pRPTemplatesRecipientNullable';


export interface RecipientPRPTemplatesRecipientNullableReference { 
    id?: string | null;
    name?: string | null;
    existing?: string | null;
    template?: PRPTemplatesRecipientNullable;
    forceExplicitRealizations?: boolean;
}

